import BaseApi from '../../../infraestructure/BaseApi';

export default class ApiCourseCategories extends BaseApi {
    constructor(client, endPoint) {
        super(client, endPoint)
    }

    findPublishedInWebSite(criteria) {
        const parameters = (criteria) ? `?${criteria}` : ''
        return this.client.get(`${this.endPoint}/published-in-website${parameters}`)
    }

    findDetailsInWebSite(id) {
        return this.client.get(`${this.endPoint}/details-in-website/${id}`)
    }

    findPublished(criteria) {
        const parameters = (criteria) ? `?${criteria}` : ''
        return this.client.get(`${this.endPoint}/published${parameters}`)
    }

    findByAuthor(criteria) {
        const parameters = (criteria) ? `?${criteria}` : ''
        return this.client.get(`${this.endPoint}/by-author${parameters}`)
    }

    findDetails(courseId) {
        return this.client.get(`${this.endPoint}/${courseId}/details`)
    }

    findDetailsLearn(courseId) {
        return this.client.get(`${this.endPoint}/${courseId}/details-learn`)
    }

    findPublishedDetails(id) {
        return this.client.get(`${this.endPoint}/details/${id}`)
    }

    doPublish(data) {
        return this.client.put(`${this.endPoint}/do-publish`, data)
    }

    doFavorite(courseId) {
        return this.client.post(`${this.endPoint}/${courseId}/favorite`)
    }

    doLike(courseId) {
        return this.client.post(`${this.endPoint}/${courseId}/like`)
    }

    doDislike(courseId) {
        return this.client.post(`${this.endPoint}/${courseId}/dislike`)
    }

    doViewed(courseId) {
        return this.client.post(`${this.endPoint}/${courseId}/viewed`)
    }

    doProgress(courseSubjectActivityId) {
        return this.client.post(`${this.endPoint}/${courseSubjectActivityId}/progress`)
    }

    doOpenAnswer(courseSubjectActivityId, data) {
        return this.client.post(`${this.endPoint}/${courseSubjectActivityId}/do-open-answer`, data)
    }

    doMultipleAnswer(courseSubjectActivityId, data) {
        return this.client.post(`${this.endPoint}/${courseSubjectActivityId}/do-multiple-answer`, data)
    }

    doFinish(courseId) {
        return this.client.put(`${this.endPoint}/${courseId}/do-finish`)
    }

    findTestTryNumber(courseSubjectActivityId) {
        return this.client.get(`${this.endPoint}/${courseSubjectActivityId}/try-test`)
    }

    doTestAnswer(courseSubjectActivityId, data) {
        return this.client.post(`${this.endPoint}/${courseSubjectActivityId}/do-test-answer`, data)
    }

    findTestAnswersDetails(courseSubjectActivityId, data){
        return this.client.post(`${this.endPoint}/${courseSubjectActivityId}/test-answer-details`, data)
    }

    findProgressByCourse(courseId) {
        return this.client.get(`${this.endPoint}/${courseId}/progress-course`)
    }

    uploadActivityFile(courseId, file) {
        return this.client.post(`${this.endPoint}/${courseId}/upload-activity-file`, file)
    }

    uploadTestActivityFile(courseId, file) {
        return this.client.post(`${this.endPoint}/${courseId}/upload-test-activity-file`, file)
    }

    getCurrentCourse(courseId) {
        return this.client.get(`${this.endPoint}/current-course/${courseId}`)
    }

    doStartCourse(courseId, careerId) {
        return this.client.post(`${this.endPoint}/start-course/${courseId}/career/${careerId}`)
    }

    removeCourseSpecialty(courseId, careerId) {
        return this.client.delete(`${this.endPoint}/current-course/${courseId}/career/${careerId}`)
    }
}